import React, { useEffect } from "react";
//import toastr from "toastr";
import { ExternalLink } from "react-external-link";
import MainLayout from "../../layout/MainLayout";
import styled from "styled-components";
import { SiGooglemaps } from "react-icons/si";
import { renderToStaticMarkup } from "react-dom/server"; // Para convertir el ícono a HTML

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import ContactInfo from "../../components/contact/ContactInfo";
import Hero from "../../components/hero/Hero";
// Styled Components
const StyledMapContainer = styled(MapContainer)`
  width: 60%;
  height: 400px;

  @media (max-width: 768px) {
    width: 100%;
    border: 0;
    padding-bottom: 0px;
    background: transparent; /* Si es necesario */
  }
`;

const Contact = (props) => {
  // Coordinates for the map center
  //const position = [51.505, -0.09];
  const position = [40.9634, -72.1848];

  // Conversión del componente React `SiGooglemaps` a HTML
  const customIconHTML = renderToStaticMarkup(
    <SiGooglemaps style={{ color: "#f44336", fontSize: "40px" }} />
  );

  // Configuración del ícono personalizado
  const customIcon = new L.DivIcon({
    html: customIconHTML, // Inserta el HTML del ícono
    iconSize: [40, 40], // Tamaño del ícono en píxeles
    className: "custom-icon", // Clase CSS para el marcador (opcional)
  });

  return (
    <MainLayout>
      <div className="pb-4  mb-4">
        <Hero title={"Contact Us"}/>
      </div>
      <ContactInfo />
      <section className="pt-4 pb-4 mt-4 mb-4 d-flex justify-content-center">
        <StyledMapContainer 
          center={position}
          zoom={13}
          className="pt-3 pb-4"
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={position} icon={customIcon}>
            <Popup>Hampton Bays, New York</Popup>
          </Marker>
        </StyledMapContainer >
      </section>
    </MainLayout>
  );
};

export default Contact;
